import {view} from '@sail/ui';

import type {StripeAssistantLiveAnswersSource} from '@stripe-internal/conversations-client';

import {dotComColors} from '../../../theme/dotCom';
import {DotComSourcesLink} from './DotComSourcesLink';

export const DotComSourceHostGroup = ({
  host,
  sources,
}: {
  host: string;
  sources: StripeAssistantLiveAnswersSource[];
}) => {
  return (
    <view.div>
      <view.div
        css={{
          color: dotComColors.brand800,
          fontSize: '12px',
          paddingLeft: '20px',
          fontWeight: '400',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {host}
      </view.div>
      <view.ul
        css={{
          stack: 'y',
          gap: 'small',
          paddingY: 'xxsmall',
          marginY: 'xsmall',
        }}
      >
        {sources.map((source, i) => (
          <view.li
            // eslint-disable-next-line react/no-array-index-key
            key={`live-answers-source-${i}`}
          >
            <DotComSourcesLink source={source} />
          </view.li>
        ))}
      </view.ul>
    </view.div>
  );
};
